import { useRef } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { IUserTypes, useUserModel } from "../userModel";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { IUserDetial } from "../userType";
import { message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
export function DetailDrawer() {
    const {
        visibleDrawer: { visible, mode },
        selectedRow,
        tabActive,
        setIVisibleDrawer,
        insertDetail,
        editDetail,
    } = useUserModel()
    const formRef = useRef<IYhFormRef>();
    const onCancel = () => {
        setIVisibleDrawer()
    }
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            mode === "edit" ? editDetail({ ...val, id: selectedRow.id }) : insertDetail(val)
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const formConfig: IYhForm<IUserDetial> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "edit" ? selectedRow : {},
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: `${tabActive === IUserTypes.USER ? "用户" : "厨师"}姓名`,
                fieldName: "name",
                rules: [{ required: true, message: "请输入员工工号" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "员工账户",
                fieldName: "account",
                rules: [{ required: true, message: "请输入员工账户" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "密码",
                fieldName: "password",
                rules: [{ required: true, message: "请输入员工账户" }],
                hidden: mode === "edit"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
                rules: [{ required: true, message: "请输入联系电话" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "branchName",
                span: 24,
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `${tabActive === IUserTypes.USER ? "用户" : "厨师"}管理${mode === "add" ? '新增' : '编辑'}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}